/* eslint-disable react/prop-types */
import CreateAnnouncementComponent from "./create-announcement";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as admin from "@/views/admin-dashboard/admin.slice";
import * as app from "@/app/app.slice";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import { getImageFileNameFromSectors } from "@/common/announcement-helper";

function CreateAnnouncement({ startAnnoucement }) {
  const dispatch = useDispatch();
  const history = useHistory();

  const services = useSelector(app.selectServices);
  const announcements = useSelector(app.selectAnnouncements);
  const status = useSelector(admin.selectStatus);

  const [announcement, setAnnouncement] = useState({ ...startAnnoucement });
  const [announcementNumber, setAnnouncementNumber] = useState(0);
  const [isConfirmEnabled, setConfirmEnabled] = useState(false);

  useEffect(() => {
    if (
      status === admin.Status.DELETED ||
      status === admin.Status.CREATED ||
      status === admin.Status.UPDATED
    ) {
      dispatch(admin.setStatus({ status: admin.Status.IDLE }));
      dispatch(app.fetchAnnouncements());
      history.push(`/admin/6484ec7b`);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const handleClickConfirm = () => {
    if (announcement.id === undefined) {
      // I'm creating a new announcement
      dispatch(
        admin.createAnnouncement({
          ...announcement,
          isPreview: true,
          cardImageFileName: getImageFileNameFromSectors({
            sector: announcement.sector,
            outgoings: announcement.outgoings,
          }),
          correlationExpire:
            announcement?.correlationExpire !== undefined
              ? announcement?.correlationExpire
              : 1,
        })
      );
    } else {
      const differences = getDiff({
        oldObj: startAnnoucement,
        newObj: announcement,
      });
      dispatch(
        admin.updateAnnouncement({ id: startAnnoucement.id, differences })
      );
    }
  };

  const handleAnnouncementNumberChange = (e) => {
    setAnnouncementNumber(e.target.value);
  };

  const handleUpdateAnnouncement = (property, value, announcement) => {
    updateAnnouncement(property, value, announcement, setConfirmEnabled);
  };

  const handleClickBack = () => {
    history.push("/admin/6484ec7b");
  };

  const handleClickDelete = () => {
    dispatch(admin.deleteAnnouncement(announcement));
  };

  const handleLoadPdfAnnouncemet = () => {
    setAnnouncement({});
  };

  return (
    <CreateAnnouncementComponent
      announcement={announcement}
      announcements={announcements}
      startAnnoucement={startAnnoucement}
      announcementNumber={announcementNumber}
      services={services}
      onAnnouncementNumberChange={handleAnnouncementNumberChange}
      onClickConfirm={handleClickConfirm}
      isConfirmEnabled={isConfirmEnabled}
      onUpdateAnnouncement={handleUpdateAnnouncement}
      onClickBack={handleClickBack}
      onClickDelete={handleClickDelete}
      onLoadPdfAnnouncemet={handleLoadPdfAnnouncemet}
      status={status}
    />
  );
}

function updateAnnouncement(property, value, announcement, setConfirmEnabled) {
  if (value === undefined) {
    return announcement;
  }
  if (!announcement) {
    const tempAnnouncement = {};
    tempAnnouncement[`${property}`] = value;
    return tempAnnouncement;
  }
  announcement[`${property}`] = value;
  setConfirmEnabled(
    announcement?.title?.length > 0 &&
      announcement?.cities?.length > 0 &&
      announcement?.regions?.length &&
      announcement?.sector?.length &&
      announcement?.outgoings?.length
  );
  return announcement;
}

function getDiff({ oldObj, newObj }) {
  var differences = {};
  Object.keys(oldObj).forEach(function (key) {
    if (!_.isEqual(oldObj[key], newObj[key])) {
      differences[`${key}`] = newObj[key];
    }
  });
  Object.keys(newObj).forEach(function (key) {
    if (!_.isEqual(newObj[key], oldObj[key])) {
      differences[`${key}`] = newObj[key];
    }
  });
  return {
    ...differences,
    isPreview: true,
  };
}

export default CreateAnnouncement;
